export { default } from './ProductCardCompact';
